import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { firestore } from "../firbase.config";
import { DOC_FORMAT,DOC_FORMAT_EXT, EMAIL_FORMAT, PASSWORD_FORMAT } from "./constants";

export const firebaseErrorMessage = (errorCode) => {
    let errorMessage = '';

    switch (errorCode) {
        case 'auth/email-already-in-use':
            errorMessage = `Usted tiene ya tiene una cuenta asociada al correo electrónico proporcionado. 
            `;
            break;
        case 'auth/email-already-exists':
            errorMessage = `Usted tiene ya tiene una cuenta asociada al correo electrónico proporcionado. 
            `;
            break;
        case 'auth/account-exists-with-different-credential':
            errorMessage = ` Usted tiene ya tiene una cuenta asociada al correo electrónico proporcionado. 
            `;
            break;


        case 'auth/user-already-exists':
            errorMessage = `Usted tiene ya tiene una cuenta asociada al documento proporcionado`;
            break;


        case 'auth/invalid-password':
            errorMessage = `El valor que se proporcionó para la propiedad del usuario password 
            no es válido. Debe ser una string con al menos seis caracteres.`;
            break;

        case 'auth/user-not-found':
            errorMessage = `No existe ningún registro de usuario con la combinación 
            email/password proporcionada`;
            break;

        case 'auth/wrong-password':
            errorMessage = `La contraseña proprcionada es incorrecta.`;
            break;

        case 'auth/unverified-user':
            errorMessage = `El usuario no está verificado, por favor revise su bandeja correo electronico en la casilla de spam`;
            break;

        case 'auth/weak-password':
            errorMessage = `La contraseña debe contener al menos 8 caracteres, un número y una letra en mayuscula`
            break;

        default:
            errorMessage = `Las credenciales de autenticación no son válidas, por favor verificar.`;
            break;
    }

    return errorMessage;
}

export const CustomError = (msg = "", code = "") => {
    this.msg = msg;
    this.code = code;
}

export const emptyString = (msg) => {
    if (msg) return msg;

    return "";
}

export const getFromStorage = (key) => {
    const value = sessionStorage.getItem(key);

    if (value && typeof value === 'object') {
        return JSON.parse(value);
    } else if (value) {
        return value;
    }

    return false;
}

export const setToStorage = (key, value) => {
    if (value && typeof value === 'object') {
        sessionStorage.setItem(key, JSON.stringify(value));
    } else if (value) {
        sessionStorage.setItem(key, value);
    }
}

export const logger = (message, severity) => {
    if (process.env.REACT_APP_LOGGER === '1') {
        switch (severity) {
            case 'error':
                console.error(message);
                break;

            case 'info':
                console.log(message);
                break;

            case 'warning':
                console.warn(message);
                break;

            default:
                console.log(message);
                break;
        }
    }
}

export const COMFE_ERROR_CODE = 'auth/wrong-comfe-info';

export const COMFE_RESET_MESSAGE = 'Ha solicitado un cambio de contraseña, por favor revise la bandeja de entrada del correo: ';

export const maskEmail = (email = '') => {
    const [name, domain] = email.split('@');
    const { length: len } = domain;
    const maskedName = name[0] + name[1] + '******';
    const maskedDomain = '******' + domain[len - 2] + domain[len - 1];
    const maskedEmail = maskedName + '@' + maskedDomain;
    return maskedEmail;
};

export const validateEmail = (email) => {
    return EMAIL_FORMAT.test(email);
}

export const validatePassword = (password) => {
    return PASSWORD_FORMAT.test(password);
}

export const validateDoc = (numDoc) => {
    return DOC_FORMAT.test(numDoc);
}
export const validateDocExt = (numDoc) => {
    return DOC_FORMAT_EXT.test(numDoc);
}

export const consultarEmpresa = async (company) => {
    try {
        let resp = false;
        const q = query(collection(firestore, "company"), where("cuenta", "==", company));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            resp = doc.data()
            resp.id = doc.id;
        });

        return resp
    } catch (error) {
        console.log('company.consultarEmpresa', error)
        throw error;
    }

}

export const consultarConfiguracion = async (idConfiguration) => {
    try {

        const docRef = doc(firestore, "configuration", idConfiguration);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            // console.log("Document data:", docSnap.data());
            return docSnap.data()
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
            return false
        }

    } catch (error) {
        console.log('company.consultarEmpresa', error)
        throw error;
    }

}

  





CustomError.prototype = Error.prototype;
